import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import { home as enHome } from "./locales/en-US/home"
import { home as esHome } from "./locales/es-ES/home"
import { home as ptHome } from "./locales/pt-BR/home"

export const SUPPORTED_LANGS = ["pt-BR", "en-US", "es-ES"] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]

export const DEFAULT_LANG: SupportedLang = "pt-BR"

const LANG_NAMES: Record<SupportedLang, { label: string; native: string; short: string }> = {
  "pt-BR": { label: "Portuguese (Brazil)", native: "Português", short: "PT" },
  "en-US": { label: "English (US)", native: "English", short: "EN" },
  "es-ES": { label: "Spanish", native: "Español", short: "ES" },
}

export function getLangMeta(lang: SupportedLang) {
  return LANG_NAMES[lang]
}

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        "pt-BR": { home: ptHome },
        "en-US": { home: enHome },
        "es-ES": { home: esHome },
      },
      fallbackLng: DEFAULT_LANG,
      supportedLngs: SUPPORTED_LANGS as unknown as string[],
      defaultNS: "home",
      ns: ["home"],
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator", "htmlTag"],
        lookupLocalStorage: "mesaotc.lang",
        caches: ["localStorage"],
      },
      returnNull: false,
      returnEmptyString: false,
    })
}

export default i18n
